import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { Select, Slider } from 'antd';
import * as _ from 'lodash';
import { connect } from 'react-redux';

import { Button } from '../../../helpers/commonUi';
// import { ReactComponent as Picker } from '../../../assets/svg/themeSelector.svg';
import { Http } from '../../../helpers/axois';
import style from './theme.module.sass';
import { RXThemeSaveAsnew } from '../../../helpers/RxServices';
import { pushToast } from '../../../stateManager/store/toast/actions'
import { setCurrentTheme } from '../../../stateManager/store/orgs/actions'
import { logger } from '../../../constant/winston';
import { Spinner } from '../../../helpers/commonUi/Spinner';
import { redirectOnError } from '../../../helpers/commonFunction';

const { Option } = Select;

const colorCodes = [
    { color: '#FA7412', id: 1 },
    { color: '#0076FF', id: 2 },
    { color: '#F50B6E', id: 3 },
    { color: '#00E535', id: 4 },
    { color: '#DDDDDD', id: 5 },
    { color: '#000000', id: 6 }
]

const colors = {
    primary: [...colorCodes]
}
const spacing = [{ name: 'Smaller', size: '18px', innerSize: '12px' }, { name: 'Normal', size: '25px', innerSize: '15px' }, { name: 'Larger', size: '35px', innerSize: '18px' }]

const border = [{ name: 'None', class: style.border }, { name: 'Soft', class: style.soft },
{ name: 'Rounded', class: style.rounded }]

const fontTypes = [{ label: 'System Font', value: 'systemfont' }, { label: 'Custom Font', value: 'customfont' }]

const sizeMarks = {
    0: {
        style: {
            'fontSize': '10px'
        },
        label: <small>h1</small>
    },
    6: {
        style: {
            'fontSize': '18px'
        },
        label: <span>h6</span>
    }
}

interface State {
    primaryColour?: string
    secondaryColour?: string
    teriartyColour?: string
    backgroundColour?: string
    lighterColour?: string
    font: string
    fontSize: any
    fontColour: string
    spacing: string,
    headerSize: number
    border: string
    shadow: boolean,
    themeDetails?: any;
    stateUpdate?: boolean
    loading: boolean
}

const defaultState = {
    primaryColour: '#0076FF',
    secondaryColour: '#0076FF',
    teriartyColour: '#0076FF',
    backgroundColour: '#0076FF',
    lighterColour: '#0076FF',
    font: 'systemfont',
    fontSize: 12,
    fontColour: '#0076FF',
    spacing: 'Smaller',
    headerSize: 3,
    border: 'Soft',
    shadow: true
}
class View extends Component<any, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            ...defaultState,
            stateUpdate: false,
            loading: true,
        }
    }

    componentDidMount() {
        const ThemeId = this.props.match.params.themeId
        this.getTheme(ThemeId);
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        const state: any = _.cloneDeep(nextState);
        delete state.themeDetails;
        delete state.stateUpdate;
        if (this.state.themeDetails) {
            const source = this.state.themeDetails.source;
            const update = _.isEqual(state, source);
            if (update !== nextState.stateUpdate) {
                this.setState({ stateUpdate: update })
            }
        }
    }

    componentWillReceiveProps(props: any) {
        const newThemeId = props.match.params.themeId
        const ThemeId = this.props.match.params.themeId
        if (newThemeId !== ThemeId) {
            this.getTheme(newThemeId);
        }
    }

    getTheme(themeId: string) {
        const orgId = this.props.match.params.orgId;
        if (themeId) {
            Http.get(`themes/${themeId}?orgId=${orgId}`).subscribe((res: any) => {
                this.setState({ themeDetails: res });
                if (res && _.size(res.source) > 0) {
                    this.setState({ ...res.source, loading: false })
                } else {
                    this.setState(defaultState);
                }
            }, (err) => {
                logger.error(err);
                const themeId = this.props.selectedThemeId;
                if (themeId) {
                    const redirectTo = `/organization/${orgId}/themeManager/${themeId}`;
                    redirectOnError(this.props.history, err.message, redirectTo, "View themes", "themeId");
                }
            })
        }
    }

    resetTheme = () => {
        const ThemeId = this.props.match.params.themeId
        this.getTheme(ThemeId)
    }

    saveTheme = () => {
        const orgId = this.props.match.params.orgId;
        const ThemeId = this.props.match.params.themeId
        const state: any = _.cloneDeep(this.state);
        delete state.themeDetails;
        delete state.stateUpdate;
        Http.put(`themes/${ThemeId}`, { source: state, orgId: orgId }).subscribe((res) => {
            this.getTheme(ThemeId);
            this.props.pushToast && this.props.pushToast(
                { type: 'success', message: 'Theme updated successfully' }
            )
            this.props.setCurrentTheme({
                id: ThemeId,
                source: state
            })
        }, (err) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'theme updation failed' }
            )
        })
    }

    saveAsNewTheme = () => {
        const state: any = _.cloneDeep(this.state);
        delete state.themeDetails;
        delete state.stateUpdate;
        RXThemeSaveAsnew.sendMessage(state);
    }
    computeFontSize(size: any) {
        const initialValue = 8
        const stepValue = 0.5
        const stepsToAdd = (size === 0) ? 0 : (size / 10)
        console.log(initialValue + (stepsToAdd * stepValue))
        return (initialValue + (stepsToAdd * stepValue))
    }
    render() {
        const orgPermissions = this.props.orgPermissions
        // const appPermissions = this.props.appPermissions
        const canEditTheme = orgPermissions.includes('theme.Edit')

        if (this.state.loading) {
            return <Spinner />
        }
       
        return (
            <React.Fragment>
                <div className={style.secondView}>
                    <div className={"row"}>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.color_header}>Theme Color</h4>
                            <ColorDiv isEditable={canEditTheme} state={this.state.primaryColour}
                                updateState={(data: any) => this.setState({ primaryColour: data })} />
                        </div>

                        {/* Disabling secondary, tertiary, lighter colors till their requirements are known */}

                        {/* <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.color_header}>Secondary Colours</h4>
                            <ColorDiv state={this.state.secondaryColour}
                                updateState={(data: any) => this.setState({ secondaryColour: data })} />
                        </div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.color_header}>Tertiary Colours</h4>
                            <ColorDiv state={this.state.teriartyColour}
                                updateState={(data: any) => this.setState({ teriartyColour: data })} />
                        </div> */}
                        {/* <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.color_header}>Background Colours</h4>
                            <ColorDiv state={this.state.backgroundColour}
                                updateState={(data: any) => this.setState({ backgroundColour: data })} />
                        </div> */}
                        {/* <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.color_header}>Lighter Colours</h4>
                            <ColorDiv state={this.state.lighterColour}
                                updateState={(data: any) => this.setState({ lighterColour: data })} />
                        </div> */}
                    </div>
                    <div className={"row"}>
                        <div className={"row " + style.header}><h4 className={style.color_header}>Typography</h4></div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Font</h4>

                            {/* Disabling fonts till font support is added */}

                            <Select data-test-id="system_font" value='systemfont' disabled onChange={(e: any) => this.setState({ font: e })} style={{ width: '80%' }}>
                                {fontTypes.map((d, index) => <Option data-test-id={`${d.label}`} key={index} value={d.value}>{d.label}</Option>)}
                            </Select>
                        </div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Font size</h4>
                            <Slider data-test-id="font_size" className={"fontSizeSlider"}
                                disabled={!canEditTheme}
                                onChange={(e: any) => canEditTheme && this.setState({ fontSize: e.toString() })}
                              value={typeof this.state.fontSize  === "number" ? this.computeFontSize(this.state.fontSize) : parseInt(this.state.fontSize)}
                                min={8}
                                max={25}
                                step={1} defaultValue={8} />
                        </div>
                        {/* <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Font color</h4>
                            <ColorDiv state={this.state.fontColour}
                                updateState={(data: any) => this.setState({ fontColour: data })} />
                        </div> */}
                    </div>
                    <div className={"row"}>
                        <div className={"row " + style.header}><h4 className={style.color_header}>Structure</h4></div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Spacing</h4>
                            <div className={style.spacing}>
                                {spacing.map((d, index) => (
                                    <div data-test-id={`theme_${d.name}`} onClick={(e) => canEditTheme && this.setState({ spacing: d.name })}
                                        className={style.spacinggroup + " " + classNames({ [style.activeClass]: d.name === this.state.spacing })}
                                        key={index}>
                                        <div key={index} style={{ width: d.size, height: d.size }} className={style.box}>
                                            <div style={{ height: d.innerSize, width: d.innerSize }} />
                                        </div>
                                        <h4 className={style.label}>{d.name}</h4>
                                    </div>))}
                            </div>
                        </div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Header Size</h4>
                            <Slider data-test-id="Header_size" className={"fontSizeSlider"}
                                disabled={!canEditTheme}
                                onChange={(e: any) => canEditTheme && this.setState({ headerSize: e })}
                                value={this.state.headerSize}
                                marks={sizeMarks} max={6} defaultValue={0} />
                        </div>
                        <div className={"col-md-4 " + style.pad}>
                            <h4 className={style.sub_header}>Border Radius</h4>
                            <div className={style.border}>
                                {border.map((d, index) => (<div key={index}
                                    data-test-id={`name_${d.name}`}
                                    onClick={() => canEditTheme && this.setState({ border: d.name })}
                                    className={style.bordergroup + " " + classNames({ [style.activeClass]: d.name === this.state.border })}>
                                    <div className={d.class}></div>
                                    <h4 className={style.label}>{d.name}</h4>
                                </div>))}
                            </div>
                        </div>
                    </div>
                    {/* <div className={"row"}>
                        <div className={"row " + style.header}><h4 className={style.color_header}>Shadow</h4></div>
                        <div className={"col-md-12"}>
                            <Checkbox
                                checked={this.state.shadow}
                                onChange={(e) => this.setState({ shadow: e.target.checked })}><label className={style.label}>Apply shadow effect</label>
                            </Checkbox>
                        </div>
                    </div> */}
                </div>
                {
                    canEditTheme &&
                    <div className={style.bottom}>
                        <div className={style.buttons}>
                            {this.state.themeDetails && !this.state.themeDetails.is_system &&
                                <Button
                                    dataTestId="save_theme"
                                    color="secondary"
                                    size='small'
                                    onClick={this.saveTheme}
                                >
                                    Save Theme
                                </Button>
                            }
                            {this.state.themeDetails && this.state.themeDetails.is_system
                                && !this.state.stateUpdate &&
                                <Button
                                    dataTestId="new_theme"
                                    color="secondary"
                                    onClick={this.saveAsNewTheme}
                                    size='small'
                                >
                                    Save as New Theme
                                </Button>
                            }
                            <Button dataTestId="reset_theme" color="secondary-outlined" size='small' onClick={this.resetTheme}>Reset Theme</Button>
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }
}

interface ColorProps {
    updateState: any
    state: any
    isEditable: boolean
}

const ColorDiv = (props: ColorProps) => {
    // const findColor = colors.primary.find((d) => d.color === props.state)
    return (<div className={style.colors}>
        {colors.primary.map((d, index) => <div key={index} className={style.boxshadow + " " + classNames({ [style.classActive]: (d.color === props.state) })} >
            <div data-test-id={`theme_color${d.color}`} key={index} onClick={(e) => props.isEditable && props.updateState(d.color)} className={style.box} style={{ background: d.color }}>
            </div>
        </div>)}

        {/* Disabling color picker till theme UI changes */}

        {/* <div className={style.boxshadow + " " + classNames({ [style.classActive]: !findColor })}
            style={{ background: (!findColor) ? props.state : null }}
        >
            <div className={style.custom}>
                <Picker />
                <input type="color" onChange={(e) => props.updateState(e.target.value)} />
            </div>
        </div> */}
    </div>)
}

const mapStateToProps = (state: any, props: any) => {
    return {
        orgPermissions: state.org.orgPermissions,
        appPermissions: state.apps.selectedApp.permissions,
        selectedThemeId: state.org.selectedTheme.id,
    }
}

export default connect(mapStateToProps, { pushToast, setCurrentTheme })(withRouter(View));
